import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("reasonsForCancellation"),
  isFetching: fetching("reasonsForCancellation"),
  isSubmitting: submitting("reasonsForCancellation"),
  items: items("reasonsForCancellation"),
  showAddModal: togglable("addModal"),
});
